<div class="container m-t-alt" *ngIf="selectedTabItem">
  <div class="columns">
    <div class="column is-12">
      <h2 class="title is-2">Resources</h2>
      <div class="mb-5">
        <a
          routerLink="/genai/publications"
          [ngClass]="{
            'is-outlined': selectedTabItem !== 'publications'
          }"
          class="button is-link ml-0 mr-4 mb-4"
          >Publications</a
        >
        <a
          routerLink="/genai/policies-and-initiatives"
          [ngClass]="{
            'is-outlined': selectedTabItem !== 'policies-and-initiatives'
          }"
          class="button is-link ml-0 mr-4 mb-4"
          >Policies & initiatives</a
        >
        <a
          routerLink="/genai/videos"
          [ngClass]="{
            'is-outlined': selectedTabItem !== 'videos'
          }"
          class="button is-link ml-0 mr-4 mb-4"
          >Videos</a
        >
      </div>
    </div>
  </div>
</div>
